import { clsx } from "clsx";
import { useDraggableScroll } from "@/hooks/use-draggable-scroll";

interface Props {
  children: React.ReactNode;
  className?: string;
  axis?: "x" | "y" | "both";
}

export const DraggableScroll = ({ children, className, axis = "x" }: Props) => {
  const { events, canScroll, ref } = useDraggableScroll();

  return (
    <div
      ref={ref}
      {...(canScroll ? events : {})}
      className={clsx(
        {
          "select-none": canScroll,
          "overflow-y-auto": axis === "y" || axis === "both",
          "overflow-x-auto": axis === "x" || axis === "both",
        },
        className,
      )}
    >
      {children}
    </div>
  );
};
